module.exports = __webpack_public_path__ + "img/paquebot.eeb3935f.png";